import API from "@/api/lib/api";

export const getAllDesserts = async (restaurant_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/desserts`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleDessert = async (item_id) => {
  try {
    const response = await API.get(`restaurant/desserts/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


export const createDessert = async (data) => {
  try {
    const response = await API.post(`restaurant/desserts`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};



export const updateDessert = async (item_id, data) => {
  try {
    const response = await API.put(`restaurant/desserts/${item_id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};


export const deleteDessert = async (item_id) => {
  try {
    const response = await API.delete(`restaurant/desserts/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};